import {
  STOCKS_GRAPH_DEMANDS_OBJECT,
  STOCKS_GRAPH_OBJECTIVE_OBJECT,
  STOCKS_GRAPH_STOCKS_OBJECT,
} from "@/domains/stocks/constants";

interface StocksBaseEntity {
  client_id?: string;
  article_id?: string;
  famille?: string;
  secteur_id?: string;
  secteur_name?: string;
  parent_id?: string;
  parent_name?: string;
}

interface Gamme extends StocksBaseEntity {
  gamme_id?: string;
  article_name?: string;
  parent_name?: string;
  parent_pdc?: string;
  pdc?: string;
  repartition?: number;
  num_sequence?: string;
  duration?: string;
  key?: string;
  stock_cible?: number;
  stock_min?: number;
}

interface StocksDetailedDataByDate {
  [STOCKS_GRAPH_DEMANDS_OBJECT]: {[date: string]: {[field: string]: number}};
  [STOCKS_GRAPH_STOCKS_OBJECT]: {[date: string]: {[field: string]: number}};
  [STOCKS_GRAPH_OBJECTIVE_OBJECT]: {[date: string]: {[field: string]: number}};
}

interface Product extends StocksBaseEntity {
  id?: string;
  article_name?: string;
  cmj?: number;
  stock_cible?: string;
  num_sequence?: string;
  op_name?: string;
  objective?: number;
  initial_stock?: number;
  demande?: number;
  final_stock?: number;
  status?: string;
  cover?: number;
  wip?: number;
  nb_previous_ops?: number;
  is_last_operation: boolean;
  production_load_strategy?: string;
  level?: string;
  children_articles?: Pick<
    Product,
    | "article_id"
    | "article_name"
    | "num_sequence"
    | "secteur_id"
    | "initial_stock"
    | "cmj"
    | "valorisation"
    | "stock_cible"
  >[];
  is_semi_fini?: boolean;
  valorisation?: string;
  parent_article_names?: string[];
  parents_with_production_range?: string[];
  children_count?: number;
  semi_finished_count?: number;
}

interface Article extends StocksBaseEntity {
  id?: string;
  article_name?: string;
  cmj?: number;
  stock_cible?: number;
  production_objective?: number;
  load?: string;
  day_date?: string;
  num_sequence?: string;
}

interface Demand extends Omit<StocksBaseEntity, "secteur_name" | "parent_id"> {
  op_id?: string;
  planned_demand?: string;
  planned_quantite_op?: number;
  planned_quantite_op_2?: number;
  raw_demand?: string;
  raw_quantite_op?: number;
  raw_quantite_op_2?: number;
  planned_ratio?: number;
  day_date?: string;
}

interface RecursiveGroupBy {
  [key: string]: Demand[] | RecursiveGroupBy;
}

interface LoadStocksParameters {
  refresh?: boolean;
  silent?: boolean;
}

interface ProductsParams extends LoadStocksParameters {
  simulationId?: string;
  siteId?: string;
  clientId?: string;
  period?: string[];
}

type GroupedByObject = {
  array: (Demand | RecursiveGroupBy)[];
  children_count: number;
  isOperation: boolean;
};

enum StocksContextFields {
  ArticleId = "article_id",
  Famille = "famille",
  NumSequence = "num_sequence",
  SecteurId = "secteur_id",
}

export {
  StocksBaseEntity,
  Gamme,
  Product,
  Article,
  Demand,
  RecursiveGroupBy,
  LoadStocksParameters,
  ProductsParams,
  GroupedByObject,
  StocksDetailedDataByDate,
  StocksContextFields,
};
